/* eslint-disable react/jsx-closing-tag-location */
import React, { useState, ReactNode } from 'react';
import cx from 'classnames';
import styles from './NbaPage.module.css';

interface CustomAccordionProps {
  title: ReactNode;
  children: ReactNode;
  defaultExpanded?: boolean;
  className?: string;
}

export const CustomAccordion: React.FC<CustomAccordionProps> = ({
  title,
  children,
  defaultExpanded = false,
  className = '',
}) => {
  const [isOpen, setIsOpen] = useState(defaultExpanded);

  return (
    <div className={cx(styles.accordion, className)}>
      <div
        className={styles.accordionHeader}
        role="button"
        tabIndex={0}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
      >
        {title}
      </div>
      {isOpen && <div className={styles.accordionContent}>
        {children}
      </div>
      }
    </div>
  );
};